// @ts-check
import React, { useState } from 'react';
import { TUTORIALS, tutorialList } from '@katsura/shared/tutorials';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { tutorialMockup } from '../components/tutorialMockups.jsx';

export default function Help() {
  const topics = tutorialList();
  const [active, setActive] = useState(topics[0]?.key ?? '');
  const tut = TUTORIALS[active];

  function launch() {
    if (!tut) return;
    const steps = tut.steps
      .filter((s) => !s.selector || document.querySelector(s.selector))
      .map((s) => ({ element: s.selector ?? null, popover: { title: s.title, description: s.text } }));
    if (!steps.length) { window.alert(`Open the ${tut.title} page first — no tour targets here.`); return; }
    driver({ showProgress: true, steps }).drive();
  }

  return (
    <div className="flex h-[calc(100vh-3rem)]">
      <aside className="w-64 border-r border-neutral-800 pr-2 overflow-auto">
        <h2 className="font-semibold mb-2">Topics</h2>
        {topics.map((t) => (
          <button
            key={t.key}
            onClick={() => setActive(t.key)}
            className={`w-full text-left px-3 py-2 rounded text-sm ${active === t.key ? 'bg-red-500 text-white' : 'text-neutral-300 hover:bg-neutral-800'}`}
          >
            {t.title}
          </button>
        ))}
      </aside>
      <section className="flex-1 overflow-auto px-6 space-y-4">
        {tut && (
          <>
            <div className="flex items-center justify-between">
              <h1 className="text-3xl font-bold">{tut.title}</h1>
              <button onClick={launch} className="btn-primary">▶ Live tour</button>
            </div>
            <div className="card">{tutorialMockup(active)}</div>
            <div className="space-y-3">
              {tut.body.map((p, i) => <p key={i} className="text-neutral-200">{p}</p>)}
            </div>
            <div className="card">
              <h3 className="font-semibold mb-2">Tour steps</h3>
              <ol className="list-decimal list-inside text-sm text-neutral-300 space-y-1">
                {tut.steps.map((s, i) => <li key={i}><b>{s.title}</b> — {s.text}</li>)}
              </ol>
            </div>
          </>
        )}
      </section>
    </div>
  );
}
